
import { window } from 'globalthis/implementation';
import React from 'react';
import Page from 'src/components/Page';
import View from "./view"


function Index(props) {

    const search = window.location.search;
    const params = new URLSearchParams(search); 
    const data = params.get('data'); 

   
    return (
        <Page >
            <View param={data}/>
        </Page>
    );
}

export default Index;